import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getCountryFlag } from '../../utils/fetchassets';
import { useUser } from '../../contexts/UserProvider';
import api from 'api';
import { Colors } from '../../styles/variables/colors';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Questionaire from './Questionnaire/Questionnaire';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { Fab, Modal } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useAuth } from 'contexts/ProtectedRoute';
import ROLES from 'assets/userRoles.json';
import { Role } from 'data/constants/roles';
import EditConfirmationModal from './EditConfirmationModal/EditConfirmationModal';
import IconBtn from 'components/common/IconBtn';
import * as S from './AssessmentReport.styled';
const { green, orange, red, blue, white } = Colors;
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3, padding: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// const myStyle = {
//     border: `1px solid ${blue}`,
//     color: darkGray,
//     '&:hover': {
//         backgroundColor: 'yellow !important',
//         color: `${white} !important`,
//     },
// };

interface Score {
    label: string;
    max_score: number;
    score: number;
    passed: boolean;
    explanation: Explanation;
}

interface PersonalInfoData {
    firstname: string;
    lastname: string;
    middlename: string;
    birth_date: Date | null;
}

const initialStatePI: PersonalInfoData = {
    firstname: '',
    lastname: '',
    middlename: '',
    birth_date: null,
};

interface UserData {
    firstname: string;
    lastname: string;
    middlename: string;
    file_number: number;
    role?: string;
}

const initialStateUser: UserData = {
    firstname: '',
    lastname: '',
    middlename: '',
    file_number: 0,
    role: '',
};

interface Explanation {
    text: string;
    table?: string[][];
}

export interface Assessment {
    region: string;
    country: string;
    program_name: string;
    program_type?: string;
    scores: Score[];
    summary: Summary;
    immigration_advice?: string;
}

interface Summary {
    score: number;
    max_score: number;
    required_score: number;
    passed: boolean;
}

interface Program {
    country: string;
    eligible_programs: [
        {
            program_name: string;
            program_type: string;
            scores: [];
            region: string;
            country: string;
            summary: {
                score: number;
                max_score: number;
                required_score: number;
                passed: boolean;
            };
        },
    ];
}

function getColor(score: number, maxScore: number) {
    const _maxScore = Math.max(1, maxScore);
    if (maxScore === 0) return green;
    else if (score / _maxScore >= 0.85) return green;
    else if (score / _maxScore >= 0.7) return orange;
    else return red;
}

function makeScore(score: number, maxScore: number) {
    const _maxScore = Math.max(1, maxScore);
    if (maxScore === 0) return 96;
    else return Math.round((100 * score) / _maxScore);
}
export default function AssessmentReports() {
    const tableName = 'PersonalInfo';
    const userTableName = 'User';
    const { role } = useAuth();
    //get the chosen client's candidate_id from the navLink
    // const candidate_id = location.state?.from;
    // const [searchParams] = useSearchParams();
    // const candidate_id = Number(Object.fromEntries([...searchParams]).id);
    const params = useParams();
    const candidate_id = Number(params.id);
    // const location = useLocation();
    const navigate = useNavigate();

    const asmnt = candidate_id === undefined || candidate_id === null || isNaN(candidate_id);

    const [active, setActive] = useState<number>(0);
    const [selectedCountry, setSelectedCountry] = useState<number>(0);
    const [data, setData] = useState(initialStatePI);
    const [userInfo, setUserInfo] = useState(initialStateUser);
    const [results, setResults] = useState<Program[]>();
    const [assessment, setAssessment] = useState<Assessment | null>(null);
    const { user } = useUser();

    useEffect(() => {
        setAssessment(null);
        if (candidate_id) {
            setData(initialStatePI);
            setUserInfo(initialStateUser);
            api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
            api.tableInput.fetchCandidateInput(setUserInfo, userTableName, candidate_id);
        } else {
            api.tableInput.fetchCandidateInput(setData, tableName);
        }

        fetchBestScoreAssessmentResults();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidate_id]);

    const fetchBestScoreAssessmentResults = async () => {
        setResults([]);
        try {
            let res;
            if (candidate_id) {
                res = await api.assessment.getTopScore(candidate_id);
            } else {
                res = await api.assessment.getTopScore();
            }
            setResults(res.data);
        } catch (e) {
            console.error(e);
        }
    };

    const handleSelect = (idx: number, country: number) => {
        setSelectedCountry(country);
        setActive(idx);
        if (results) {
            setAssessment(results[country].eligible_programs[idx]);
        }
    };

    const isActive = (idx: number, country: number) => {
        return active === idx && country === selectedCountry ? 'active' : '';
    };

    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const [open, setOpen] = useState<boolean>(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const profileLabel =
        ROLES.visaCandidate === role ||
        ROLES.completedAssessment === role ||
        ROLES.academicConsultation === role
            ? 'MY PROFILE'
            : 'CLIENT PROFILE';

    const programErrorMessage =
        userInfo.role === Role.CANDIDATE || (user && user.role === Role.CANDIDATE)
            ? 'Assessment cannot be performed as the client has not input all the required information'
            : 'No eligible programs';

    return (
        <>
            <S.Assessment asmnt={asmnt}>
                <Box
                    sx={{
                        padding: '0px',
                        p: 3,
                        '&.MuiBox-root': {
                            padding: '0px',
                        },
                    }}
                >
                    <S.ButtonContainer>
                        <span>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                                TabIndicatorProps={{
                                    hidden: true,
                                    sx: {},
                                }}
                            >
                                <S.Tab
                                    label="Result"
                                    {...a11yProps(0)}
                                    sx={{
                                        mr: '18px',
                                        '&.Mui-selected': {
                                            backgroundColor: blue,
                                            color: white,
                                            border: 'unset !important',
                                        },
                                        '&.MuiTabPanel-root': {
                                            padding: '0',
                                        },
                                    }}
                                    onClick={() => navigate('')}
                                />
                                <S.Tab
                                    label={profileLabel}
                                    {...a11yProps(1)}
                                    sx={{
                                        '&.Mui-selected': {
                                            backgroundColor: blue,
                                            color: white,
                                            border: 'unset !important',
                                        },
                                    }}
                                    onClick={() => navigate('general')}
                                />
                            </Tabs>
                        </span>
                        {(ROLES.visaCandidate === role ||
                            ROLES.completedAssessment === role ||
                            ROLES.academicConsultation === role) && (
                            <S.EditContainer>
                                <Fab
                                    size="small"
                                    sx={[
                                        {
                                            zIndex: 0,
                                            minWidth: 40,
                                            color: blue,
                                            border: `1px solid ${blue}`,
                                            backgroundColor: white,
                                        },
                                        (theme) => ({
                                            '&:hover': {
                                                backgroundColor: `${blue} !important`,
                                                color: white,
                                                border: 'unset',
                                            },
                                        }),
                                    ]}
                                    aria-label="edit"
                                    onClick={() => handleOpen()}
                                >
                                    <Edit />
                                </Fab>
                                <S.EditProfile>Edit Profile</S.EditProfile>
                                <Modal sx={{ zIndex: '10000' }} open={open} onClose={handleClose}>
                                    <S.ModalWrapper>
                                        <S.Modal>
                                            <EditConfirmationModal closeModal={handleClose} />
                                            <S.ModalBtnWrapper>
                                                <IconBtn
                                                    style={{ height: '24px', width: '24px' }}
                                                    onClick={handleClose}
                                                >
                                                    <S.CrossSimpleIcon />
                                                </IconBtn>
                                            </S.ModalBtnWrapper>
                                        </S.Modal>
                                    </S.ModalWrapper>
                                </Modal>
                            </S.EditContainer>
                        )}
                    </S.ButtonContainer>
                </Box>

                <TabPanel value={value} index={0}>
                    <S.Gap />
                    <S.ReportContainer>
                        <S.SideBarReport>
                            {results && results.length ? (
                                results.map((vals, idx) => {
                                    return (
                                        <CountryProgramList
                                            key={idx}
                                            countryIdx={idx}
                                            country={vals.country}
                                            eligible_programs={vals.eligible_programs}
                                            isActive={isActive}
                                            handleSelect={handleSelect}
                                        />
                                    );
                                })
                            ) : (
                                <h3>{programErrorMessage}</h3>
                            )}
                        </S.SideBarReport>

                        <S.ReportBody asmnt={asmnt}>
                            <S.ReportBodyTitle>Assessment Report</S.ReportBodyTitle>
                            <S.ReportBodyItems>
                                <AssessmentHeader assessment={assessment} />
                                <HeaderPersonalInfo personalInfo={data} userInfo={userInfo} />
                                <AssessmentBody assessment={assessment} />
                            </S.ReportBodyItems>
                            <ReportFooter assessment={assessment} />
                            <ImmigrationAdvice assessment={assessment} />
                        </S.ReportBody>
                    </S.ReportContainer>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Questionaire data={candidate_id} />
                </TabPanel>
            </S.Assessment>
        </>
    );
}

function AssessmentHeader({ assessment }: { assessment: Assessment | null }) {
    if (!assessment) return <></>;

    return (
        <>
            <S.ReportBodyItem>
                <S.ItemBody>{assessment.program_type}</S.ItemBody>
                <S.ItemHeaderBig>{assessment.program_name}</S.ItemHeaderBig>
            </S.ReportBodyItem>
            <S.ReportBodyItem>
                <S.ItemHeader>
                    Country: <S.ItemBody>{assessment.country}</S.ItemBody>
                </S.ItemHeader>
            </S.ReportBodyItem>
            <S.ReportBodyItem>
                <S.ItemHeader>
                    {assessment.region ? (
                        <>
                            Region:{' '}
                            <S.ItemBody>{assessment.region ? assessment.region : 'all'}</S.ItemBody>
                        </>
                    ) : (
                        <></>
                    )}
                </S.ItemHeader>
            </S.ReportBodyItem>
        </>
    );
}

function HeaderPersonalInfo({
    personalInfo,
    userInfo,
}: {
    personalInfo: PersonalInfoData;
    userInfo: UserData;
}) {
    const params = useParams();
    const candidate_id = Number(params.id);
    const { user } = useUser();

    const birth_date =
        !personalInfo || !personalInfo.birth_date
            ? ''
            : candidate_id
              ? new Date(personalInfo.birth_date).toLocaleString('en-AU', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                })
              : personalInfo?.birth_date
                ? new Date(personalInfo?.birth_date ?? '').toLocaleString('en-AU', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                  })
                : '';

    const name = candidate_id
        ? [userInfo.firstname, userInfo.middlename, userInfo.lastname].join(' ')
        : [user?.firstname, user?.middlename, user?.lastname].join(' ');

    const file_number = candidate_id ? userInfo.file_number : user?.file_number;

    return (
        <>
            <S.ReportBodyItem>
                <S.ItemHeader>
                    File number: <S.ItemBody>{file_number}</S.ItemBody>
                </S.ItemHeader>
            </S.ReportBodyItem>
            <S.ReportBodyItem>
                <S.ItemHeader>
                    Candidate name: <S.ItemBody>{name}</S.ItemBody>
                </S.ItemHeader>
            </S.ReportBodyItem>
            <S.ReportBodyItem>
                <S.ItemHeader>
                    Date of Birth: <S.ItemBody>{birth_date}</S.ItemBody>
                </S.ItemHeader>
            </S.ReportBodyItem>
        </>
    );
}

function CountryProgramList({
    countryIdx,
    country,
    eligible_programs,
    isActive,
    handleSelect,
}: {
    countryIdx: number;
    country: string;
    eligible_programs: Assessment[];
    isActive: CallableFunction;
    handleSelect: CallableFunction;
}) {
    return (
        <>
            <div>
                <S.SideBarCollection>
                    <Accordion defaultExpanded>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography component="div">
                                <S.SideBarCollectionHeader>
                                    <img
                                        src={
                                            window.location.protocol +
                                            '//' +
                                            window.location.host +
                                            getCountryFlag(country)
                                        }
                                        alt={country}
                                    />
                                    <div>{country}</div>
                                </S.SideBarCollectionHeader>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography component="div">
                                <S.SideBarCollectionBody>
                                    {eligible_programs.map((value, i) => {
                                        // let countryTmp = 0;
                                        const badgeColor = getColor(
                                            value.summary.score,
                                            value.summary.max_score
                                        );
                                        return (
                                            <S.SideBarCollectionItem
                                                key={i}
                                                active={isActive(i, countryIdx) === 'active'}
                                                onClick={() => handleSelect(i, countryIdx)}
                                            >
                                                <S.CollectionItemHeader>
                                                    {value.program_type}
                                                </S.CollectionItemHeader>
                                                <S.CollectionItemBody>
                                                    <S.CollectionItemText>
                                                        {value.program_name}
                                                    </S.CollectionItemText>
                                                    <S.CollectionItemBadge
                                                        style={{ background: badgeColor }}
                                                    >
                                                        {makeScore(
                                                            value.summary.score,
                                                            value.summary.max_score
                                                        )}
                                                        %
                                                    </S.CollectionItemBadge>
                                                </S.CollectionItemBody>
                                            </S.SideBarCollectionItem>
                                        );
                                    })}
                                </S.SideBarCollectionBody>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </S.SideBarCollection>
            </div>
        </>
    );
}

function AssessmentBody({ assessment }: { assessment: Assessment | null }) {
    if (!assessment) return <></>;

    return (
        <div style={{ marginTop: 20 }}>
            {assessment.scores.map((item, idx) => (
                <CategoryScore key={idx} idx={idx} item={item} />
            ))}
        </div>
    );
}
function CategoryScore({ item, idx }: { item: Score; idx: number }) {
    const score = item.max_score
        ? String(item.score) + ' / ' + String(item.max_score)
        : 'No Score In This Category';
    return (
        <S.ReportBodyItem>
            <S.ItemHeader>
                {idx + 1 + '. ' + item.label}
                <S.Badge>
                    <img
                        src={
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            '/check-simple.png'
                        }
                        alt="check"
                    />
                    Pass
                </S.Badge>
            </S.ItemHeader>
            <S.ItemBody>{item.explanation.text}</S.ItemBody>
            <S.ItemBody style={{ fontWeight: 'bold', marginBottom: 25 }}>Score: {score}</S.ItemBody>
        </S.ReportBodyItem>
    );
}

function ImmigrationAdvice({ assessment }: { assessment: Assessment | null }) {
    if (!assessment || assessment.immigration_advice === undefined) return <></>;
    return (
        <S.ReportBodyItem>
            <S.ItemHeader>Description</S.ItemHeader>
            <S.ItemBody>{assessment.immigration_advice}</S.ItemBody>
        </S.ReportBodyItem>
    );
}

function ReportFooter({ assessment }: { assessment: Assessment | null }) {
    if (assessment === null)
        return (
            <S.ReportBodyFooter>
                <S.FooterIcon>
                    <img
                        src={
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            '/human-resources.png'
                        }
                        alt="human_res"
                    />
                </S.FooterIcon>
                <S.FooterBody>
                    <S.FooterDescription>
                        Select program in sidebar to view assessment report
                    </S.FooterDescription>
                </S.FooterBody>
            </S.ReportBodyFooter>
        );

    const ScoreComponent = () => {
        const { score, max_score } = assessment.summary;
        if (max_score) {
            return (
                <S.ProgramScore style={{ fontWeight: 'bold' }}>
                    Program score: {String(score) + ' / ' + String(max_score)}
                </S.ProgramScore>
            );
        } else {
            return <></>;
        }
    };

    return (
        <S.ReportBodyFooter>
            <S.FooterIcon>
                <img
                    src={
                        window.location.protocol +
                        '//' +
                        window.location.host +
                        '/human-resources.png'
                    }
                    alt="human_res"
                />
            </S.FooterIcon>
            <S.FooterBody>
                <S.FooterTitle>
                    <img src={getCountryFlag(assessment.country)} alt="state" />
                    Likely Eligible
                </S.FooterTitle>
                <S.FooterDescription>
                    You are likely Eligible under the requirements of the {assessment.region}{' '}
                    {assessment.program_name}.
                </S.FooterDescription>
                <ScoreComponent />
            </S.FooterBody>
        </S.ReportBodyFooter>
    );
}
